import { render, staticRenderFns } from "./RolesInput.vue?vue&type=template&id=16a7dc43&"
import script from "./RolesInput.vue?vue&type=script&lang=js&"
export * from "./RolesInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports